export default __webpack_public_path__ + "static/media/screenshot1.c2e0726e.jpg";